import { ColumnFilter } from 'primeng/table';

let patched = false;

/**
 * `overlayAppendTo: 'body'` renders the column-filter menu's own selects (operator,
 * match mode) outside the menu, so PrimeNG treats picking an option as an outside
 * click and closes the menu.
 */
export function keepColumnFilterOpenOnSelectOverlays(): void {
	if (patched) {
		return;
	}
	patched = true;

	const isOutsideClicked = ColumnFilter.prototype.isOutsideClicked;
	ColumnFilter.prototype.isOutsideClicked = function (
		this: ColumnFilter,
		event: MouseEvent
	): boolean {
		const target = event.target as Element | null;
		return (
			!target?.closest?.('.p-select-overlay') &&
			isOutsideClicked.call(this, event)
		);
	};
}
